<script setup lang="ts">
import { useAuthStore } from '@stores/useAuthStore';
import SearchMap from '@pages/search/components/map/SearchMap.vue';
import { useScreensizeStore } from '@stores/useScreensizeStore.ts';
import { useSearchStore } from '@stores/useSearchStore.ts';
import { storeToRefs } from 'pinia';
import Modal from '@components/Modal.vue';
import { trans } from '@tools/translation';

const { isImpersonated } = useAuthStore();

const { isMobileOrTablet } = storeToRefs(useScreensizeStore());

const searchStore = useSearchStore();
const { mapIsVisible } = storeToRefs(searchStore);
const { closeMap } = searchStore;
</script>

<template>
  <div
    class="search-map-section"
    :class="{ impersonated: isImpersonated }"
  >
    <Modal
      v-if="isMobileOrTablet"
      :is-opened="mapIsVisible"
      :on-close="closeMap"
      class="search-map-section__modal"
    >
      <template #header>
        {{ trans('global.map') }}
      </template>

      <template #body>
        <SearchMap
          v-if="mapIsVisible"
          class="size-full"
        />
      </template>
    </Modal>

    <div
      v-else
      class="search-map-section__container"
    >
      <SearchMap class="size-full" />
    </div>
  </div>
</template>

<style scoped lang="scss">
@use 'sass:math';
@use '@styles/variables' as *;
@use '@styles/mixins' as *;

$searchMapMarginTop: 20;
$searchMapFilterHeight: 80;

$topHeadersSize: toRem($headerSize + math.div($searchMapMarginTop, 2) + $searchMapFilterHeight);

.search-map-section {
  @media screen and (min-width: $breakTablet) {
    top: $topHeadersSize;

    @apply sticky size-full;
  }

  &__container {
    height: calc(100vh - $topHeadersSize);

    @apply rounded-2xl overflow-hidden;
  }

  &__modal {
    :deep(.modal-container) {
      @apply size-full;

      @apply p-0;
    }

    :deep(.modal-title) {
      @apply hidden;
    }
  }
}
</style>
